import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';
import { nullNoop } from 'utils/noop';

import {
  StyledBadge as StyledBadgeDefault,
  StyledClickableContainer as StyledContainer,
} from './incentive-card.styled.default';

export * from './incentive-card.styled.default';

export const StyledClickableContainer = styled(StyledContainer)`
  background-color: ${Styles.color.white};
`;

export const StyledLockIcon = nullNoop;

export const StyledBadge = styled(StyledBadgeDefault)`
  border-color: ${primitive.bk.$bbqBrown};
  & > div > svg > path {
    fill: ${primitive.bk.$bbqBrown};
  }
`;
